import React from 'react';
import PropTypes from 'prop-types';

import { SELECT_PAYMENT_MODAL_NAME } from './constants';
import { ensureCurrencyIsPresent } from './util';

/** @param {any} props */
export default function ProtectionAndSupportTooltip({
  amountInDollars,
  onOpenModalClick,
  isDogPayment = false
}) {
  const amountWithCurrencySign = ensureCurrencyIsPresent(
    parseFloat(amountInDollars).toFixed(2)
  );

  const TOOLTIP_COPY = isDogPayment
    ? `This fully protects your ${amountWithCurrencySign} payment, which keeps your payment 
    safe and allows our team to step in and support you if anything goes wrong. Plus, access 
    to our Puppy Training Program, discounts, coaching, and community.`
    : `This fully protects your ${amountWithCurrencySign} deposit, which means your payment will be safe, and our team 
    can step in and support you if any issues pop up.`;

  return (
    <div className="ProtectionAndSupportTooltip fw-medium ph4 pv4 tl">
      <p className="mb2">{TOOLTIP_COPY}</p>
      <button
        className="underline"
        type="button"
        onClick={() => onOpenModalClick(SELECT_PAYMENT_MODAL_NAME.LEARN_MORE)}
      >
        Learn more
      </button>
    </div>
  );
}

ProtectionAndSupportTooltip.propTypes = {
  amountInDollars: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  onOpenModalClick: PropTypes.func.isRequired,
  isDogPayment: PropTypes.bool
};
